import React, { Component } from 'react';
import 'video-react/dist/video-react.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-select/dist/react-select.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css'
import './styles/index.css';
import autobind from 'react-autobind'
import { ClipLoader } from 'react-spinners'
import { reactLocalStorage } from 'reactjs-localstorage';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import routes from './routes';
import * as loginActions from "./redux/actions/loginActions"

class App extends Component {

  constructor(props) {
    super(props)

    this.state = {
      checkLoginFinish: false
    }
    autobind(this)
  }

  componentWillMount() {
    const { actions } = this.props;

    actions.checkLogin().then(() => {
      const localStoragePath = reactLocalStorage.get('lastRoutePath')

      const lastPath = !localStoragePath || localStoragePath === "null" || localStoragePath === "undefined" ? '/' : localStoragePath
      window.location.replace(`${window.location.protocol}//${window.location.host}/#${lastPath}`)

      this.setState({
        checkLoginFinish: true
      })
    }).catch((error) => {
      this.setState({
        checkLoginFinish: true
      });
      //console.error(error);
    });
  }

  render() {
    const { checkLoginFinish } = this.state;
    if (checkLoginFinish) {
      return (
        <div>{ routes }</div>
      );
    } else {
      return (
        <div className="main-loader">
          <ClipLoader
            color="#2CC185"
            loading
          />
        </div>
      )
    }

  }

}

App.propTypes = {
  actions: PropTypes.object.isRequired,
}

function mapStateToProps(state, ownProps) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(loginActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js